<!-- eslint-disable vue/no-v-html -->
<template>
  <section
    class="relative w-full overflow-hidden bg-cover bg-center bg-no-repeat after:absolute after:left-0 after:top-0 after:block after:h-full after:w-full after:bg-gradient-to-r after:from-white after:to-white/0 after:content-['']"
    :style="bannerStyle"
  >
    <div
      class="container-wrap relative z-10 flex h-mobile-banner py-2 tablet:h-banner"
    >
      <div class="flex w-full max-w-[760px] flex-col justify-center">
        <div>
          <h1 class="text-h1 banner-title mb-2">
            {{ productName }}
          </h1>
          <p
            class="banner-description is-mobile-hidden mb-3 tablet:whitespace-pre-line"
            v-text="productBanner.description"
          ></p>
        </div>
        <div class="mt-8 tablet:flex tablet:items-center">
          <TheButton
            :id="isCN ? 'tracking_requestdemo' : undefined"
            :to="`/${$i18n.locale}/marketplace/products/${$route.params.id}/request-demo`"
            :title="t('products.book-a-demo')"
            class="mb-2 w-full tablet:mb-0 tablet:w-[180px]"
          >
            <span class="text-sm">{{ t('products.book-a-demo') }}</span>
          </TheButton>
          <TheButton
            v-if="hasFreeTrialPlan"
            :to="`/${$i18n.locale}/marketplace/pricing/${$route.params.id}#free-trial-plan`"
            :title="t('products.try-it-free')"
            type="freeTrial"
            class="w-full tablet:ml-4 tablet:w-[180px]"
          >
            <span class="text-sm">{{ t('products.try-it-free') }}</span>
          </TheButton>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  const { t } = useI18n();
  const { blobDomain } = useWebsite();
  const { isCN } = useLanguage();
  const { isMobile, isTablet } = useScreen();
  const { provideResponsiveImgName } = useImagePath();

  const productsStore = useProductsStore();
  const { productName, productBanner, hasFreeTrialPlan } =
    storeToRefs(productsStore);

  const bannerImageUrl = computed((): string => {
    const { webBanner, tabletBanner, mobileBanner } = productBanner.value;
    if (isMobile.value && mobileBanner) return mobileBanner;
    if (isTablet.value && tabletBanner) return tabletBanner;
    if (webBanner) return webBanner;
    return `${blobDomain.value}/wise-paas-marketplace/product/${provideResponsiveImgName('product-banner')}`;
  });

  const bannerStyle = computed((): string => {
    return `background-image: url(${bannerImageUrl.value})`;
  });
</script>
